import Index from "./Index/Index";
import Users from "./Users/Index";

// Inventory

import Inventory from "./Inventory";
import InventoryDetail from "./Inventory/InventoryDetail"

// Point Change History

import PointChangeHistory from "./PointChangeHistory";

// Tours
import Tours from "./Tours";
import TourDetail from "./Tours/TourDetail";
import DetailTourTicketDetail from "./Tours/TourDetail/TourTabs/TourTicket/TourTicketDetail";

// Tour properties
import TourProperties from './TourProperties/index';
import TourPropertiesAction from './TourProperties/component/ActionComponent';

// Tour Tickets
import TourTickets from "./TourTickets";
import TourTicketDetail from "./TourTickets/TourTicketDetail";

import Suppliers from "./Suppliers";
import SupplierDetail from "./Suppliers/SupplierDetail";
import SupplierProductDetail from './Suppliers/SupplierProductDetail';
import SupplierUsagePlanDetail from "./Suppliers/SupplierUsagePlanDetail";
import Banners from "./Banners/Index";
import ToursAction from "./Tours/component/ActionComponent";
import UsersAction from "./Users/component/ActionComponent";
import BannersAction from "./Banners/component/ActionComponent";
import Error from "./Error";
import Component403 from "./403/Index";
import Login from "../Login";
import Orders from "./Orders/Index";
import OrdersAction from "./Orders/component/ActionComponent";
import OrderDetail from "./Orders/OrderDetail";
import Products from "./Products/Index";
import ProductsAction from "./Products/component/ActionComponent";
import Groups from "./Groups/Index";
import GroupsAction from "./Groups/component/ActionComponent";
import GroupCategories from "./GroupCategories";
import GroupCategoryDetail from "./GroupCategories/GroupCategoryDetail";
import CheckVoucher from "./CheckVoucher/Index";
import Vouchers from "./Vouchers/Index";
import VouchersAction from "./Vouchers/component/ActionComponent";
import ViewComponent from "./Vouchers/component/ViewComponent";
import ImportComponent from "./Vouchers/component/ImportComponent";
import Properties from "./Properties/Index";
import PropertiesAction from "./Properties/component/ActionComponent";
import UserProfile from "./UserProfile";
import Roles from "./Roles/Index";
import RolesAction from "./Roles/component/ActionComponent";
import Hotels from "./Hotels";
import HotelDetail from "./Hotels/HotelDetail";
import RoomTypes from "./RoomTypes";
import RoomTypesDetail from "./RoomTypes/RoomTypesDetail";
import Locations from "./Locations";
import LocationDetail from "./Locations/LocationDetail";
import CustomPrices from "./CustomPrices";
import CustomPriceDetail from "./CustomPrices/CustomPriceDetail";
import PopularPlaces from "./PopularPlaces";
import PopularPlaceDetail from "./PopularPlaces/PopularPlaceDetail";
import Categories from "./Categories";
import CategoryDetail from "./Categories/CategoryDetail";
import Pages from "./Pages";
import PageDetail from "./Pages/PageDetail";
import Posts from "./Posts";
import PostDetail from "./Posts/PostDetail";
import Ratings from "./Ratings";
import RatingDetail from "./Ratings/RatingDetail";
import PriceMakeupFlight from './PriceMakeupFlight';
//REPORT
import Reports from './Reports';
import ReportsOrder from "./Reports/ReportsOrder";
import { SaleReportsBySKU, OrderDetailReportsBySKU } from './Reports/ReportsSKU';
import ReportCashFlow from './Reports/ReportCashFlow';
import SiteInfo from "./SiteInfo";
import SiteInfoDetail from "./SiteInfo/SiteInfoDetail";
import CollaboratorReport from "./Reports/CollaboratorReport";
import BtbUseRoomReport from "./Reports/BtbUseRoomReport";
import { OrderDetailReportsByHotel } from './Reports/ReportsHotel';
import BundleReport from "./Reports/BundleReport";
import BtbOrderReport from "./Reports/BtbOrderReport";
//TICKETS
import Tickets from './Tickets';
import TicketDetail from "./Tickets/TicketDetail";
import MyTickets from "./Tickets/MyTickets";
import TicketAssignConfigs from './TicketAssignConfigs';
import TicketAssignConfigDetail from "./TicketAssignConfigs/TicketAssignConfigDetail";
//SYSTEM
import ExchangeRates from "./System/ExchangeRates";
//AGENTS
import Agents from "./Agents";
import AgentsDetail from './Agents/AgentDetail';
//EMAIL Template
import EmailTemplates from "./EmailTemplates";
import EmailTemplateDetail from "./EmailTemplates/EmailTemplateDetail";

//RATE CODE
import RateCode from "./RateCode";
import RateCodeDetail from "./RateCode/RateCodeDetail";
import RateCodeUsagePlanDetail from './RateCode/RateCodeUsagePlanDetail';

//SUPPLIER CATEGORY
import SupplierCategory from "./SupplierCategory";
import SupplierCategoryDetail from "./SupplierCategory/CategoryDetail";

//SUPPLIER CATEGORY VW
import SupplierCategoryVW from "./SupplierCategoryVW";
import SupplierCategoryDetailVW from "./SupplierCategoryVW/detail";

//GOLF
import GolfCourse from "./Golf/index";
import GolfCourseDetail from "./Golf/GolfDetail/index";
//AIRPORT
import Airports from './Airports';
import AirportDetail from './Airports/AirportDetail';

//FARE RULE
import FareRules from './FareRules';
import FareRuleDetail from './FareRules/FareRuleDetail';

// SourceFlight
import SourceFlight from './SourceFlight'; //SourceFlight

//BAGGAGE
import Baggages from './Baggages';
import BaggageDetail from './Baggages/BaggageDetail';

//VIN-WONDER
import VinWonders from './VinWonders';
import VinWonderDetail from './VinWonders/VinWonderDetail';

import VinWonderTickets from './VinWonderTickets';
import VinWonderTicketDetail from './VinWonderTickets/VinWonderTicketDetail';

import VinWonderPrices from './VinWonderPrices';
import VinWonderPriceDetail from './VinWonderPrices/VinWonderPriceDetail';

import VinWonderCheck from './VinWonderCheck';

import Rates from './Rates'
import RateDetail from './Rates/RateDetail'

import BookablePackageRates from './BookablePackageRates';
import BookablePackageRateDetail from './BookablePackageRates/BookablePackageRateDetail';

import PackageRates from './PackageRates';
import PackageRateDetail from './PackageRates/PackageRateDetail';

import Amenities from './Amenities'
import AmenityDetail from './Amenities/AmenityDetail'

import ProductFeed from './ProductFeed'
import ProductReindex from './ProductReindex'

import TagGroup from './TagGroup'

import Promotions from './Promotions'
import BundleDetail from "./Promotions/BundleDetail";
import Campaigns from "./Campaigns";
import CampaignDetail from "./Campaigns/CampaignDetail";
import ObjectTypes from "./ObjectTypes";
import ObjectTypeDetail from "./ObjectTypes/ObjectTypeDetail";
import CheckPromotion from "./CheckPromotion";
import AutoFill from './AutoFill';
import AutoFillDetail from './AutoFill/AutoFillDetail';

import RedirectLinks from './RedirectLinks'
import RedirectLinkDetail from './RedirectLinks/RedirectLinkDetail'
//Config PHS
import PHSMaster from './ConfigPHS';

import TicketSolds from './TicketSolds'
//Website
import PayAtHotel from './PayAtHotel'
import Recommendation from './Recommendation';

import MarkupBundles from './MarkupBundles'
import MarkupBundleDetail from './MarkupBundles/MarkupBundleDetail'

import CashFlowDetail from "./Reports/ReportCashFlow/CashFlowDetail";

import AppUI from "./AppUI"
import AppUIDetail from './AppUI/AppUIDetail'
import WhitelistIp from './AppUI/AppUIWhitelistIp'
import RateCompare from "./RateCompare";
import RateCompareDetail from "./RateCompare/RateCompareDetail";
import Homestays from "./Homestays";
import HomestayDetail from "./Homestays/HomestayDetail";
import GolfDetail from "./Golf/GolfDetail";
import HomestayRoomTypes from "./HomestayRoomTypes";
import HomestayRoomTypeDetail from "./HomestayRoomTypes/HomestayRoomTypesDetail";
import HomestayRates from "./HomestayRates";
import HomestayRateDetail from "./HomestayRates/HomestayRateDetail";
import ClearCache from "./ClearCache";

import OutletFnBList from "./FnB/Outlet/OutletList/index";
import OutletFnBDetail from "./FnB/Outlet/OutletDetail/index";
import ProductFnBList from "./FnB/Product/ProductList/index";
import ProductFnBDetail from "./FnB/Product/ProductDetail/index";
import Menu from "./FnB/Menu";
import MenuSub from "./FnB/Menu/MenuSub";
import MenuDetail from "./FnB/Menu/MenuDetail";
import MenuSubDetail from "./FnB/Menu/MenuSubDetail";
import Condiment from "./FnB/Condiment";
import CondimentSetMenu from "./FnB/Condiment/CondimentSetMenu";
import CondimentDetail from "./FnB/Condiment/CondimentDetail";
import Option from "./FnB/Option";
import OptionSetItems from "./FnB/Option/OptionSetItems";
import OptionDetail from "./FnB/Option/OptionDetail";
// import MenuManagerFnB from "./FnB/Menu/MenuManager";

export default {
    Index,
    Users,
    UsersAction,
    SiteInfo,
    SiteInfoDetail,
    //Inventory
    Inventory,
    InventoryDetail,
    //PointChangeHistory
    PointChangeHistory,
    //Tour
    Tours,
    TourDetail,
    DetailTourTicketDetail,
    TourTickets,
    TourTicketDetail,
    TourProperties,
    TourPropertiesAction,

    Suppliers,
    SupplierDetail,
    SupplierProductDetail,
    SupplierUsagePlanDetail,
    Banners,
    ToursAction,
    BannersAction,
    Error,
    Component403,
    Login,
    //rate code
    RateCode,
    RateCodeDetail,
    RateCodeUsagePlanDetail,
    //supplier category
    SupplierCategory,
    SupplierCategoryDetail,
    SupplierCategoryVW,
    SupplierCategoryDetailVW,
    // Order
    Orders,
    OrdersAction,
    OrderDetail,
    //EmailTemplate
    EmailTemplates,
    EmailTemplateDetail,
    //Voucher section
    Products,
    ProductsAction,
    Groups,
    GroupsAction,
    GroupCategories,
    GroupCategoryDetail,
    CheckVoucher,
    Vouchers,
    VouchersAction,
    ViewComponent,
    Properties,
    PropertiesAction,
    ImportComponent,
    UserProfile,
    Hotels,
    Homestays,
    Roles,
    RolesAction,
    HotelDetail,
    HomestayDetail,
    RoomTypes,
    RoomTypesDetail,
    HomestayRoomTypes,
    HomestayRoomTypeDetail,

    // Rate
    Rates,
    RateDetail,
    RateCompare,
    RateCompareDetail,

    // Homestay Rate
    HomestayRates,
    HomestayRateDetail,
    // RateCompare,
    // RateCompareDetail,
    //Golf
    GolfCourse,
    GolfCourseDetail,
    // Bookable Package Rates
    BookablePackageRates,
    BookablePackageRateDetail,

    // Package Rates
    PackageRates,
    PackageRateDetail,

    Locations,
    LocationDetail,
    CustomPrices,
    CustomPriceDetail,
    PopularPlaces,
    PopularPlaceDetail,
    //CONTENTS
    Categories,
    CategoryDetail,
    Pages,
    Menu,
    MenuSub,
    PageDetail,
    Posts,
    PostDetail,
    Ratings,
    RatingDetail,
    // Flight Kakeup
    PriceMakeupFlight,
    //Report
    Reports,
    ReportsOrder,
    SaleReportsBySKU,
    ReportCashFlow,
    OrderDetailReportsBySKU,
    CollaboratorReport,
    OrderDetailReportsByHotel,
    BundleReport,
    BtbOrderReport,
    BtbUseRoomReport,
    //Tickets
    Tickets,
    TicketDetail,
    MyTickets,
    TicketAssignConfigs,
    TicketAssignConfigDetail,
    //System
    ExchangeRates,
    //Agent
    Agents,
    AgentsDetail,

    //Airport
    Airports,
    AirportDetail,

    //Fare Rule
    FareRules,
    FareRuleDetail,
    SourceFlight,
    //Baggages
    Baggages,
    BaggageDetail,

    //Vin-Wonder
    VinWonders,
    VinWonderDetail,

    VinWonderTickets,
    VinWonderTicketDetail,

    VinWonderPrices,
    VinWonderPriceDetail,

    VinWonderCheck,

    // Amenities
    Amenities,
    AmenityDetail,

    ProductFeed,
    ProductReindex,
    TagGroup,

    // Promotions
    Promotions,
    CheckPromotion,
    BundleDetail,

    //AutoFill
    AutoFill,
    AutoFillDetail,

    // Campaigns
    Campaigns,
    CampaignDetail,

    // Object Types
    ObjectTypes,
    ObjectTypeDetail,

    //Redirect Link
    RedirectLinks,
    RedirectLinkDetail,
    TicketSolds,
    //Config PHS
    PHSMaster,
    //Website
    PayAtHotel,
    Recommendation,

    //MakeupBundles
    MarkupBundles,
    MarkupBundleDetail,

    // Cashflow
    CashFlowDetail,

    // App UI
    AppUI,
    AppUIDetail,
    WhitelistIp,
    //Golf
    GolfDetail,
    ClearCache,

    OutletFnBList,
    OutletFnBDetail,
    MenuDetail,
    MenuSubDetail,
    Condiment,
    CondimentSetMenu,
    CondimentDetail,
    Option,
    OptionSetItems,
    OptionDetail,
    ProductFnBList,
    ProductFnBDetail,
};
